import React, { useEffect, useState } from 'react'
import logoExpress from '../../assets/images/navbar/tarot.png'
import './navbar.css'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Dispatch } from 'redux'
import { CheckUser, Logout } from '../../store/actions'
import { useWidth } from '../../hooks/useWidth'

const Navbar = () => {
    const navigate = useNavigate()
    const user = useSelector((state: any) => state.user)
    const dispatch: Dispatch<any> = useDispatch()
    const location = useLocation()
    const [item, setItem] = useState('')
    const [show, setShow] = useState(false)
    const [openSubmenu, setOpenSubmenu] = useState<string | null>(null)
    const width = useWidth()
    const isMobileMenu = width < 1280

    useEffect(() => {
        switch (location.pathname) {
            case '/manual/three':
            case '/auto/pregunta':
            case '/auto/2-preguntas':
            case '/auto/3-preguntas':
            case '/auto/4-preguntas':
            case '/auto/5-preguntas':
                setItem('preguntas')
                break
            case '/auto/compatibilidad':
            case '/auto/free':
            case '/auto/vidapasada':
            case '/auto/evolutivo':
            case '/auto/mejor':
            case '/auto/proteccion':
            case '/auto/abundancia':
            case '/auto/trabajo':
            case '/auto/infidelidad':
            case '/auto/futuro':
            case '/auto/combo':
            case '/auto/autoconocimiento':
            case '/auto/atraccion':
            case '/auto/love':
            case '/auto/ex-pareja':
            case '/general':
            case '/auto/renacer':
                setItem('consultas')
                break
            case '/auto/yo-futuro':
            case '/auto/temporada':
            case '/auto/interior':
            case '/auto/bloqueo':
            case '/auto/propio':
            case '/auto/encrucijada':
            case '/auto/guias':
            case '/auto/romper':
            case '/auto/carta-natal':
                setItem('especiales')
                break
            case '/iching/pregunta':
                setItem('iching')
                break
            case '/login':
                setItem('login')
                break
            case '/about':
                setItem('about')
                break
            default: {
                setItem('home')
                break
            }
        }
        if (Object.entries(user).length === 0) {
            let saveUser = localStorage.getItem('user')
            if (saveUser) {
                const currentUser = JSON.parse(saveUser)
                dispatch(CheckUser(currentUser!.sessionToken))
            }
        }
    }, [location.pathname, user, dispatch])

    useEffect(() => {
        setShow(false)
        setOpenSubmenu(null)
    }, [width])

    useEffect(() => {
        if (!show) setOpenSubmenu(null)
    }, [show])

    const toggleSubmenu = (id: string) => {
        if (!isMobileMenu) return
        setOpenSubmenu((prev) => (prev === id ? null : id))
    }

    const submenuVisibleClass = (id: string, hoverClass: string) =>
        `${openSubmenu === id ? 'block' : 'hidden'} ${hoverClass}`

    const handleItems = (value: string): void => {
        if (
            (item !== 'consultas' && item !== 'especiales' && item !== 'clientes' && item !== user.username) ||
            (item === 'consultas' && value === 'consultas') ||
            (item === 'especiales' && value === 'especiales') ||
            (item === 'preguntas' && value === 'preguntas')
        ) {
            setShow(false)
        }
        setOpenSubmenu(null)
        setItem(value)
    }

    const handleLogout = () => {
        dispatch(Logout(user.sessionToken))
        navigate('/')
    }

    return (
        <div className="w-full h-[60px] flex flex-row items-center justify-between z-[99] sticky top-0 bg-white mini:px-3 lg:px-20">
            <Link to="/" className="no-underline">
                <div className="flex items-center gap-[10px]">
                    <img src={logoExpress} alt="" className="w-[50px] h-[50px]" />
                    <span className="font-black mini:text-base xl:text-3xl">Tarot</span>
                    <span className="font-black mini:text-base xl:text-3xl text-violetDark">Express</span>
                </div>
            </Link>
            <div
                className={
                    show
                        ? 'mini:absolute xl:relative flex xl:flex-row mini:flex-col mini:items-start xl:items-center mini:gap-5 mini:top-[60px] xl:top-auto mini:right-0 xl:right-auto mini:bg-white mini:p-5 xl:p-0 mini:rounded-bl-3xl xl:rounded-none xl:gap-[calc(100vw * 0.001)] shadow-lg translate-x-0 duration-500'
                        : 'flex xl:flex-row mini:flex-col mini:absolute xl:relative mini:top-[60px] xl:top-auto mini:right-0 xl:right-auto mini:bg-white xl:bg-transparent mini:items-start mini:p-5 xl:p-0 mini:rounded-bl-xl xl:rounded-none xl:items-center xl:gap-[calc(100vw * 0.001)] mini:translate-x-full xl:translate-x-0 duration-500'
                }
            >
                <Link to="/about" className="no-underlinek">
                    <div
                        className={
                            item === 'about'
                                ? 'text-base font-semibold py-[5px] px-[25px] text-white bg-violetDark rounded-2xl'
                                : 'text-base font-normal py-[5px] px-[25px] cursor-pointer hover:scale-110 duration-200'
                        }
                        onClick={() => handleItems('about')}
                    >
                        Sobre el Tarot
                    </div>
                </Link>

                {Object.entries(user).length > 0 && (
                    <div className="relative h-full align-middle" id="preguntas">
                        <div className="group/preguntas h-full flex flex-col xl:flex-row xl:items-center">
                            <div
                                className={
                                    item === 'preguntas'
                                        ? 'text-base font-semibold py-[5px] px-[25px] text-white bg-violetDark rounded-2xl'
                                        : 'text-base font-normal py-[5px] px-[25px] cursor-pointer hover:scale-110 duration-200'
                                }
                                onClick={() => toggleSubmenu('preguntas')}
                            >
                                Preguntas
                            </div>

                            <div
                                className={`mini:relative xl:absolute xl:left-0 xl:top-full xl:-mt-1 xl:pt-1 bg-white xl:rounded-b-xl xl:py-[10px] xl:px-[20px] xl:z-[100] ${submenuVisibleClass(
                                    'preguntas',
                                    'xl:group-hover/preguntas:block'
                                )}`}
                            >                                <Link to="/auto/sino" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('preguntas')}
                                    >
                                        Tirada del SI o NO
                                    </div>
                                </Link>
                                <Link to="/auto/pregunta" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('preguntas')}
                                    >
                                        Tirada para 1 Pregunta
                                    </div>
                                </Link>
                                <Link to="/auto/2-preguntas" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('preguntas')}
                                    >
                                        Tirada para 2 Preguntas
                                    </div>
                                </Link>
                                <Link to="/auto/3-preguntas" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('preguntas')}
                                    >
                                        Tirada para 3 Preguntas
                                    </div>
                                </Link>
                                <Link to="/auto/4-preguntas" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('preguntas')}
                                    >
                                        Tirada para 4 Preguntas
                                    </div>
                                </Link>
                                <Link to="/auto/5-preguntas" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('preguntas')}
                                    >
                                        Tirada para 5 Preguntas
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                )}
                {Object.entries(user).length > 0 && (
                    <div className="relative h-full align-middle" id="consultas">
                        <div className="group/consultas h-full flex flex-col xl:flex-row xl:items-center">
                            <div
                                className={
                                    item === 'consultas'
                                        ? 'text-base font-semibold py-[5px] px-[25px] text-white bg-violetDark rounded-2xl'
                                        : 'text-base font-normal py-[5px] px-[25px] cursor-pointer hover:scale-110 duration-200'
                                }
                                onClick={() => toggleSubmenu('consultas')}
                            >
                                Consultas
                            </div>
                            <div
                                className={`mini:relative xl:absolute xl:left-0 xl:top-full xl:-mt-1 xl:pt-1 bg-white xl:rounded-b-xl xl:py-[10px] xl:px-[20px] xl:z-[100] ${submenuVisibleClass(
                                    'consultas',
                                    'xl:group-hover/consultas:block'
                                )}`}
                            >                                <Link to="/manual/three" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('consultas')}
                                    >
                                        Manual
                                    </div>
                                </Link>
                                <Link to="/auto/combo" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('consultas')}
                                    >
                                        Combo de lecturas
                                    </div>
                                </Link>
                                <Link to="/auto/love" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('consultas')}
                                    >
                                        Tirada del Amor
                                    </div>
                                </Link>
                                <Link to="/auto/ex-pareja" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('consultas')}
                                    >
                                        Tirada de Ex Pareja
                                    </div>
                                </Link>
                                <Link to="/general" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('consultas')}
                                    >
                                        Tirada General
                                    </div>
                                </Link>
                                <Link to="/auto/celta" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('consultas')}
                                    >
                                        Tirada de la Cruz Celta
                                    </div>
                                </Link>
                                <Link to="/auto/vidapasada" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('consultas')}
                                    >
                                        Vida Pasada
                                    </div>
                                </Link>
                                <Link to="/auto/evolutivo" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('consultas')}
                                    >
                                        Tarot Evolutivo
                                    </div>
                                </Link>
                                <Link to="/auto/proteccion" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('consultas')}
                                    >
                                        Tirada de Protección y Energía
                                    </div>
                                </Link>
                                <Link to="/auto/abundancia" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('consultas')}
                                    >
                                        Tirada de Abundancia y Prosperidad
                                    </div>
                                </Link>
                                <Link to="/auto/trabajo" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('consultas')}
                                    >
                                        Lectura Laboral
                                    </div>
                                </Link>
                                <Link to="/auto/infidelidad" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('consultas')}
                                    >
                                        Lectura de Infidelidad
                                    </div>
                                </Link>
                                <Link to="/auto/futuro" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('consultas')}
                                    >
                                        Lectura del Futuro
                                    </div>
                                </Link>
                                <Link to="/auto/autoconocimiento" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('consultas')}
                                    >
                                        Tirada de Autoconocimiento Profundo
                                    </div>
                                </Link>
                                <Link to="/auto/atraccion" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('consultas')}
                                    >
                                        Tirada de Atracción Magnética
                                    </div>
                                </Link>
                                <Link to="/auto/renacer" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('consultas')}
                                    >
                                        Tirada Renacer del Propósito
                                    </div>
                                </Link>
                                <Link to="/auto/compatibilidad" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('consultas')}
                                    >
                                        Compatibilidad de la Pareja
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                )}
                {user?.level === 1 && (
                    <div className="relative h-full align-middle" id="especiales">
                        <div className="group/especiales h-full flex flex-col xl:flex-row xl:items-center">
                            <div
                                className={
                                    item === 'especiales'
                                        ? 'text-base font-semibold py-[5px] px-[25px] text-white bg-violetDark rounded-2xl'
                                        : 'text-base font-normal py-[5px] px-[25px] cursor-pointer hover:scale-110 duration-200'
                                }
                                onClick={() => toggleSubmenu('especiales')}
                            >
                                Especiales
                            </div>
                            <div
                                className={`mini:relative xl:absolute xl:left-0 xl:top-full xl:-mt-1 xl:pt-1 bg-white xl:rounded-b-xl xl:py-[10px] xl:px-[20px] xl:z-[100] ${submenuVisibleClass(
                                    'especiales',
                                    'xl:group-hover/especiales:block'
                                )}`}
                            >                                <Link to="/auto/yo-futuro" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('especiales')}
                                    >
                                        Tirada de Conexión con tu Yo Futuro
                                    </div>
                                </Link>
                                <Link to="/auto/temporada" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('especiales')}
                                    >
                                        Tirada de Temporada Actual del Alma
                                    </div>
                                </Link>
                                <Link to="/auto/interior" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('especiales')}
                                    >
                                        Tirada de Sanación del Niño Interior
                                    </div>
                                </Link>
                                <Link to="/auto/bloqueo" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('especiales')}
                                    >
                                        Tirada de Liberación de Bloqueo del Dinero
                                    </div>
                                </Link>
                                <Link to="/auto/propio" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('especiales')}
                                    >
                                        Tirada de Amor Propio y Merecimiento
                                    </div>
                                </Link>
                                <Link to="/auto/encrucijada" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('especiales')}
                                    >
                                        Tirada de Encrucijada del Alma
                                    </div>
                                </Link>
                                <Link to="/auto/guias" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('especiales')}
                                    >
                                        Tirada de Mensaje de tus Guías
                                    </div>
                                </Link>
                                <Link to="/auto/romper" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('especiales')}
                                    >
                                        Tirada de Romper Patrones Repetitivos
                                    </div>
                                </Link>
                                <Link to="/auto/carta-natal" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('especiales')}
                                    >
                                        Carta natal (informe premium)
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                )}
                {user?.level === 1 && (
                    <div className="relative h-full align-middle" id="manual">
                        <div className="group/manual h-full flex flex-col xl:flex-row xl:items-center">
                            <div
                                className={
                                    item === 'manual'
                                        ? 'text-base font-semibold py-[5px] px-[25px] text-white bg-violetDark rounded-2xl'
                                        : 'text-base font-normal py-[5px] px-[25px] cursor-pointer hover:scale-110 duration-200'
                                }
                                onClick={() => toggleSubmenu('manual')}
                            >
                                Manual
                            </div>
                            <div
                                className={`mini:relative xl:absolute xl:left-0 xl:top-full xl:-mt-1 xl:pt-1 bg-white xl:rounded-b-xl xl:py-[10px] xl:px-[20px] xl:z-[100] ${submenuVisibleClass(
                                    'manual',
                                    'xl:group-hover/manual:block'
                                )}`}
                            >                                <Link to="/manual/pregunta" className="no-underline">
                                    <div
                                        className="mini:text-sm xl:text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[24px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems('manual')}
                                    >
                                        1 Pregunta
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                )}
                {Object.entries(user).length > 0 && user.level === 1 && (
                    <div className="relative h-full align-middle" id="clientes">
                        <div className="group/clientes">
                            <Link to="/iching/pregunta" className="no-underline">
                                <div
                                    className={
                                        item === 'iching'
                                            ? 'text-base font-semibold py-[5px] px-[25px] text-white bg-violetDark rounded-2xl'
                                            : 'text-base font-normal py-[5px] px-[25px] cursor-pointer hover:scale-110 duration-200'
                                    }
                                    onClick={() => handleItems('iching')}
                                >
                                    I-Ching
                                </div>
                            </Link>
                        </div>
                    </div>
                )}

                {Object.entries(user).length === 0 && (
                    <Link to="/login" className="no-underline">
                        <div
                            className={
                                item === 'login'
                                    ? 'text-base font-semibold py-[5px] px-[25px] text-white bg-violetDark rounded-2xl'
                                    : 'text-base font-normal py-[5px] px-[25px] cursor-pointer hover:scale-110 duration-200'
                            }
                            onClick={() => handleItems('login')}
                        >
                            Login
                        </div>
                    </Link>
                )}
                {Object.entries(user).length > 0 && (
                    <div className="relative h-full align-middle" id="user">
                        <div className="group/user h-full flex flex-col xl:flex-row xl:items-center">
                            <div
                                className={
                                    item === user.username
                                        ? 'text-base font-semibold py-[5px] px-[25px] text-white bg-violetDark rounded-2xl'
                                        : 'text-base font-normal py-[5px] px-[25px] cursor-pointer hover:scale-110 duration-200'
                                }
                                onClick={() => {
                                    toggleSubmenu('user')
                                    if (!isMobileMenu) handleItems(user.username)
                                }}
                            >
                                {user.username}
                            </div>

                            <div
                                className={`mini:relative xl:absolute xl:left-0 xl:top-full xl:-mt-1 xl:pt-1 bg-white xl:rounded-b-xl py-[10px] px-[20px] z-[100] ${submenuVisibleClass(
                                    'user',
                                    'xl:group-hover/user:block'
                                )}`}
                                id="submenuuser"
                            >
                                <Link to="/user/myconsults" className="no-underline">
                                    <div
                                        className="text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[20px] whitespace-nowrap hover:bg-zinc-100"
                                        onClick={() => handleItems(user.username)}
                                    >
                                        Mis Consultas
                                    </div>
                                </Link>
                                {user.level === 1 && (
                                    <>
                                        <Link to="/user/allconsults" className="no-underline">
                                            <div
                                                className="text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[20px] whitespace-nowrap hover:bg-zinc-100"
                                                onClick={() => handleItems(user.name)}
                                            >
                                                Todas las Consultas
                                            </div>
                                        </Link>
                                        <Link to="/user/usuarios" className="no-underline">
                                            <div className="text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[20px] whitespace-nowrap hover:bg-zinc-100">
                                                Usuarios
                                            </div>
                                        </Link>
                                        <Link to="/user/ajustes-foto" className="no-underline">
                                            <div
                                                className="text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[20px] whitespace-nowrap hover:bg-zinc-100"
                                                onClick={() => handleItems(user.username)}
                                            >
                                                Ajustes de foto
                                            </div>
                                        </Link>
                                    </>
                                )}
                                <div
                                    className="text-base font-normal w-[calc(100% - 44px)] py-[7px] px-[20px] whitespace-nowrap hover:bg-zinc-100 hover:cursor-pointer"
                                    onClick={() => handleLogout()}
                                >
                                    Cerrar sesión
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div
                className={
                    show ? 'w-fit mini:block xl:hidden duration-500 pr-2' : 'w-fit mini:block xl:hidden duration-500'
                }
                onClick={() => setShow(!show)}
            >
                <div
                    className={
                        show
                            ? 'w-[35px] h-[1px] border-2 border-solid border-[#504e4e] bg-[#504e4e] rounded-sm duration-500 mb-2 rotate-45 translate-x-2 translate-y-[10px]'
                            : 'w-[35px] h-[1px] border-2 border-solid border-[#504e4e] bg-[#504e4e] rounded-sm duration-500 mb-2'
                    }
                ></div>
                <div
                    className={
                        show
                            ? 'w-[35px] h-[1px] border-2 border-solid border-[#504e4e] bg-[#504e4e] rounded-sm duration-500 mb-2 opacity-0'
                            : 'w-[35px] h-[1px] border-2 border-solid border-[#504e4e] bg-[#504e4e] rounded-sm duration-500 mb-2'
                    }
                ></div>
                <div
                    className={
                        show
                            ? 'w-[35px] h-[1px] border-2 border-solid border-[#504e4e] bg-[#504e4e] rounded-sm duration-500 -rotate-45 translate-x-2 -translate-y-[14px]'
                            : 'w-[35px] h-[1px] border-2 border-solid border-[#504e4e] bg-[#504e4e] rounded-sm duration-500'
                    }
                ></div>
            </div>
        </div>
    )
}

export default Navbar
